import Vue from 'vue';
import FbActivation from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './localizer';

Vue.config.productionTip = false;

new FbActivation({
  router,
  store,
  i18n,
}).$mount('#app');
